import { render } from "./MenuSidebar.vue?vue&type=template&id=0018fb78&lang=html"
import script from "./MenuSidebar.vue?vue&type=script&lang=js"
export * from "./MenuSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__